import type { ContactService } from './analytics';

const SERVICE_PREFIXES: ReadonlyArray<readonly [string, ContactService]> = [
  ['/reparation-telephone', 'reparation-telephone'],
  ['/reparation-iphone', 'reparation-telephone'],
  ['/depannage-informatique', 'depannage'],
  ['/creation-site-web', 'site-web'],
  ['/creation-site-internet', 'site-web'],
];

/** Déduit le service concerné à partir du chemin de la page courante. */
export function getServiceFromPath(pathname: string): ContactService {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const match = SERVICE_PREFIXES.find(([prefix]) => normalized.startsWith(prefix));
  return match ? match[1] : 'autre';
}
